/**
 * Created by Bart Decorte
 * Date: 23/02/2020
 * Time: 13:03
 */
import LoadingStateColumn from './LoadingStateColumn';
import toasts from '../toasts/ToastManager';
import Dropzone from '../components/uploads/Dropzone';
import Swal from 'sweetalert2';

export default class AssetColumn extends LoadingStateColumn {
  constructor(params) {
    super(params);
    this.dropzone = new Dropzone(this.dropzoneEl(), params);
    this.initDeleteBtn();
    this.updatePreviewElements();
  }

  bindListeners() {
    this.dropzone.on('change', data => this.lDropzoneChanged(data));
    this.dropzone.on('canceled', () => this.lDropzoneCanceled());
    this.dropzone.on('failure', () => this.lDropzoneFailed());
    this.dropzone.on('success', () => this.lDropzoneSucceeded());
    this.dropzone.on('progress', () => this.lDropzoneProgressed());
  }

  initDeleteBtn() {
    if (this.buttonDeleteEl()) {
      this.buttonDeleteEl().addEventListener('click', ev => this.delete(ev));
    }
  }

  updatePreviewElements() {
    if (this.previewImageEl()) {
      this.previewImageStoredUrl = this.previewImageEl().getAttribute('data-stored-url');
    } else {
      this.previewImageStoredUrl = null;
    }
    if (this.previewFileEl()) {
      this.previewFileStoredFilename = this.previewFileEl().getAttribute('data-stored-filename');
    } else {
      this.previewFileStoredFilename = null;
    }
    if (this.previewImageStoredUrl && this.buttonDeleteEl()) {
      this.buttonDeleteEl().classList.remove('d-none');
    }
    if (this.previewFileStoredFilename && this.buttonDeleteEl()) {
      this.buttonDeleteEl().classList.remove('d-none');
    }
  }

  async delete(ev) {
    const confirmDelete = await this.launchDeleteModal();
    if (confirmDelete) {
      this.deletePreviewImage(this.previewImageEl(), this.previewFileEl(), ev);
    }
  }

  deletePreviewImage(previewImage, previewFile, ev) {
    const deleteBtn = ev.target;
    deleteBtn.style.display = 'none';
    this.downloadButtonEl().classList.add('disabled');
    if (previewImage) {
      previewImage.style.backgroundImage = '';
      previewImage.removeAttribute('data-stored-url');
    }
    if (previewFile) {
      previewFile.removeAttribute('data-stored-filename');
    }
    this.deleteInputEl().value = "1";
    this.setFilesSelected(false);
  }

  async launchDeleteModal() {
    const { isConfirmed, isDismissed } = await Swal.fire({
      title: 'Are you sure?',
      text: 'The image will be deleted when this form is saved.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText:
        typeof cancelText !== typeof undefined ? cancelText : 'Cancel',
      confirmButtonText:
        typeof continueText !== typeof undefined ? continueText : 'Continue',
      customClass: {
        confirmButton: 'btn ml-1 mr-1 btn-danger',
        cancelButton: 'btn ml-1 mr-1 btn-light',
      },
      buttonsStyling: false,
    });
    if (isConfirmed) {
      let ce = new MouseEvent('click', {
        clientX: -1000,
      });
      return true;
    } else if (isDismissed) {
      return false;
    }
  }

  lDropzoneChanged({files}) {
    this.updateDownloadButtonState(files[0]);
    this.emitBusyState(true);
  }

  lDropzoneCanceled() {
    this.restore();
    this.updateDownloadButtonState();
    this.emitBusyState(false);
  }

  lDropzoneFailed() {
    toasts().danger(`File failed to upload`);
    this.emitBusyState(false);
  }

  lDropzoneSucceeded() {
    if (this.settingsButtonEl()) {
    this.settingsButtonEl().classList.remove('d-none');
    }
    if (this.buttonDeleteEl()) {
      this.buttonDeleteEl().classList.add('d-none');
    }
    this.emitBusyState(false);
  }

  lDropzoneProgressed() {

  }

  isIdle() {
    return !this.upload || !this.upload.active;
  }

  setButtonState(which, state) {
    let $btn = this.$root.find('.js-btn-' + which);
    if (state && $btn.hasClass('disabled')) {
      $btn.removeClass('disabled');
    } else if (!state && !$btn.hasClass('disabled')) {
      $btn.addClass('disabled');
    }
  };

  updateDownloadButtonState() {
    return this;
  }

  dropzoneEl() {
    return this.rootEl.querySelector('.js-dropzone-wrap');
  }

  buttonDeleteEl() {
    return this.dropzoneEl().querySelector('.js-btn-delete');
  }

  previewImageEl() {
    return this.dropzoneEl().querySelector('.js-preview-image');
  }

  previewFileEl() {
    return this.dropzoneEl().querySelector('.js-filename');
  }

  deleteInputEl() {
    return this.dropzoneEl().querySelector('.js-delete-input');
  }

  downloadButtonEl() {
    return this.dropzoneEl().querySelector('.js-btn-download');
  }
  settingsButtonEl() {
    return this.dropzoneEl().querySelector('.js-btn-settings');
  }

  hasDeleteButton() {
    return !!this.deleteBtnEl();
  }

  restore() {

  }

  setFilesSelected(hasFilesSelected) {
    const cssClass = 'no-files-selected';

    if (hasFilesSelected && this.dropzoneEl().classList.contains(cssClass)) {
      this.dropzoneEl().classList.remove(cssClass);
    } else if (! hasFilesSelected && ! this.dropzoneEl().classList.contains(cssClass)) {
      this.dropzoneEl().classList.add(cssClass);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/columns/AssetColumn.js